export default "__VITE_ASSET__BIXLVn2F__"